var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"overlay",staticClass:"full-overlay",class:{'hidden': !_vm.showOverlay},style:({'z-index': _vm.zIndex}),on:{"click":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }